module.exports = __webpack_public_path__ + "static/media/lamp.67a57c45.jpg";